"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This index.ts file will be used during development because it will
 * be found by the typescript compiler.
 */
__exportStar(require("./src"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQTs7O0dBR0c7QUFDSCx3Q0FBc0IiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFRoaXMgaW5kZXgudHMgZmlsZSB3aWxsIGJlIHVzZWQgZHVyaW5nIGRldmVsb3BtZW50IGJlY2F1c2UgaXQgd2lsbFxuICogYmUgZm91bmQgYnkgdGhlIHR5cGVzY3JpcHQgY29tcGlsZXIuXG4gKi9cbmV4cG9ydCAqIGZyb20gJy4vc3JjJztcbiJdfQ==